// Minimal cookie helpers — no external dependency needed.
// Browsers cap each cookie at ~4KB, which is why the logo file
// (a base64 image) is intentionally NOT persisted here — it would
// blow past that limit almost immediately. Everything else in the
// form easily fits.

export function setCookie(name, value, days = 365) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getCookie(name) {
  const match = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`));
  if (!match) return null;

  const value = match.split("=").slice(1).join("=");
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
}

export function deleteCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function setJSONCookie(name, obj, days = 365) {
  setCookie(name, JSON.stringify(obj), days);
}

export function getJSONCookie(name) {
  const raw = getCookie(name);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}